export default __webpack_public_path__ + "static/media/m1873.23fb3ed7.svg";